/** URL `?tab=` values for employee overview (shareable / bookmarkable). */
export const EmployeeOverviewTabParam = {
  OVERVIEW: "overview",
  SALARY_STRUCTURES: "salary-structures",
  BANK_DETAILS: "bank-details",
  PAYSLIPS: "payslips",
  ADVANCES: "advances",
} as const;

export type EmployeeOverviewTabParamValue =
  (typeof EmployeeOverviewTabParam)[keyof typeof EmployeeOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, EmployeeOverviewTabParamValue> = {
  "1": EmployeeOverviewTabParam.OVERVIEW,
  "2": EmployeeOverviewTabParam.SALARY_STRUCTURES,
  "3": EmployeeOverviewTabParam.BANK_DETAILS,
  "4": EmployeeOverviewTabParam.PAYSLIPS,
  "5": EmployeeOverviewTabParam.ADVANCES,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [EmployeeOverviewTabParam.OVERVIEW]: "1",
  [EmployeeOverviewTabParam.SALARY_STRUCTURES]: "2",
  [EmployeeOverviewTabParam.BANK_DETAILS]: "3",
  [EmployeeOverviewTabParam.PAYSLIPS]: "4",
  [EmployeeOverviewTabParam.ADVANCES]: "5",
};

export function employeeOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForEmployeeOverviewTabId(
  tabId: string,
): EmployeeOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidEmployeeOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
